import { apiClient } from "./client";

export type LeaderboardType = "tokens-earned" | "wheel-spins" | "referrals";

export interface LeaderboardEntry {
  rank: number;
  userId: string;
  username: string | null;
  /** BigInt-safe stringified value: tokens for tokens-earned, count for the others. */
  value: string;
  isMe: boolean;
}

export interface LeaderboardResponse {
  type: LeaderboardType;
  entries: LeaderboardEntry[];
  /** The current user's row, present whether or not they're in `entries`. */
  me: LeaderboardEntry | null;
  generatedAt: string;
}

export async function fetchLeaderboard(
  type: LeaderboardType,
  limit = 50
): Promise<LeaderboardResponse> {
  const { data } = await apiClient.get<LeaderboardResponse>(
    `/leaderboard/${type}`,
    { params: { limit } }
  );
  return data;
}
